import { createFileRoute } from "@tanstack/react-router";
import { SugestoesCombinacoesPage } from "@/pages/SugestoesCombinacoesPage";

export const Route = createFileRoute("/sugestoes-combinacoes/")({
  head: () => ({ meta: [{ title: "Sugestões de Combinações — AXIS" }] }),
  component: SugestoesCombinacoesPage,
});
